import React from "react";

interface ProgressBarProps {
  progressPercent: number;
}

export default function ProgressBar({ progressPercent }: ProgressBarProps) {
  return (
    <>
      {/* <h5 style={{ textAlign: "center", color: "white" }}>
        Your Progress
        <p
          style={{
            position: "relative",
            paddingTop: 8,
            fontWeight: "bold",
            color: "black",
            marginBottom: "-31px",
            fontSize: 14,
          }}
        >
          {progressPercent}%
        </p>
      </h5>
      <div className="progress">
        <div className="progress-bar" style={{ width: progressPercent + "%" }}></div>
      </div> */}
      <div className="star-points-progress-wrapper">
        <div className="star-points-progress d-flex align-items-center gap-3">
          <div className="progress-star-icon">
            <img src="/images/star-icons.png" />
          </div>
          <div className="flex-grow-1">
            <div className="progress" style={{ height: 12 }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: progressPercent + "%" }}
                aria-valuenow={25}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
            <p className="mt-2 mb-0">Your Progress: {progressPercent}%</p>
          </div>
        </div>
      </div>
    </>
  );
}
